import { PRODUCT_MORTGAGES } from '@/constants/products';
import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/mortgage';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  await $apolloQuery(getProviders, { product: PRODUCT_MORTGAGES }).then(providers => store.commit('providers/setList', providers));
  const description = store.$i18n.t('lenders.description');
  const subtitle = store.$i18n.t('lenders.subtitle');
  const title = store.$i18n.t('lenders.title');
  store.commit('pageContent/setHead', { description, title });
  store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
};
